/* Provencelia, 28/09/2026 : vignettes de coloris sur une seule ligne (fiche produit),
   deux lignes sur mobile depuis le 13/10/2026.
   Chaque rangée marquée data-pv-une-ligne (snippets/product-variations-custom-color) ne
   montre que ce qui tient sur la première ligne ; la dernière place devient une vignette
   « +N » qui déplie toute la rangée (et « − » pour la replier). Le coloris sélectionné
   reste toujours visible. Recalculé quand la largeur change. Sans JavaScript : rangée
   complète, comme avant. */
(function () {
  'use strict';

  function styliser(bouton, modele) {
    var r = modele.getBoundingClientRect();
    var s = getComputedStyle(modele);
    bouton.style.cssText = [
      'width:' + r.width + 'px',
      'height:' + r.height + 'px',
      'display:inline-grid',
      'place-items:center',
      'flex:none',
      'border:1px solid rgb(var(--text-color) / .15)',
      'border-radius:' + (s.borderRadius || '8px'),
      'background:#fff',
      'color:rgb(var(--text-color))',
      'font-size:15px',
      'letter-spacing:.02em',
      'cursor:pointer',
      'transition:border-color .2s'
    ].join(';');
    bouton.onmouseenter = function () { bouton.style.borderColor = 'rgb(var(--text-color))'; };
    bouton.onmouseleave = function () { bouton.style.borderColor = 'rgb(var(--text-color) / .15)'; };
  }

  function estSelection(el) {
    return el.getAttribute('aria-current') === 'true' || el.getAttribute('aria-checked') === 'true'
      || el.classList.contains('is-selected') || !!el.querySelector('[aria-current="true"], [aria-checked="true"], .is-selected');
  }

  function replier(rangee) {
    var items = Array.prototype.filter.call(rangee.children, function (c) { return !c.hasAttribute('data-pv-plus'); });
    var ancien = rangee.querySelector('[data-pv-plus]');
    if (ancien) ancien.remove();
    items.forEach(function (i) { i.style.display = ''; });
    if (rangee.dataset.pvOuvert === '1' || items.length < 2) return;

    // 13/10/2026 : deux lignes sur mobile (< 700 px) pour montrer plus de coloris ;
    // une seule ligne sur desktop, comme avant.
    var lignes = window.matchMedia('(max-width: 699px)').matches ? 2 : 1;
    var hauts = [];
    var tiennent = 0;
    for (var k = 0; k < items.length; k++) {
      var t = items[k].offsetTop;
      var connue = false;
      for (var h = 0; h < hauts.length; h++) {
        if (Math.abs(hauts[h] - t) <= 2) { connue = true; break; }
      }
      if (!connue) {
        if (hauts.length >= lignes) break;
        hauts.push(t);
      }
      tiennent++;
    }
    if (tiennent >= items.length) return; // tout tient sur les lignes autorisées

    var visibles = Math.max(1, tiennent - 1); // une place pour « +N »
    var montres = items.slice(0, visibles);
    var choisi = items.filter(estSelection)[0];
    if (choisi && montres.indexOf(choisi) < 0) montres[montres.length - 1] = choisi;

    var caches = 0;
    items.forEach(function (i) {
      if (montres.indexOf(i) < 0) { i.style.display = 'none'; caches++; }
    });

    var bouton = document.createElement('button');
    bouton.type = 'button';
    bouton.setAttribute('data-pv-plus', '');
    bouton.setAttribute('aria-expanded', 'false');
    bouton.textContent = '+' + caches;
    styliser(bouton, items[0]);
    bouton.addEventListener('click', function () {
      rangee.dataset.pvOuvert = '1';
      replier(rangee);
      var moins = document.createElement('button');
      moins.type = 'button';
      moins.setAttribute('data-pv-plus', '');
      moins.setAttribute('aria-expanded', 'true');
      moins.textContent = '−';
      styliser(moins, items[0]);
      moins.addEventListener('click', function () {
        rangee.dataset.pvOuvert = '0';
        replier(rangee);
      });
      rangee.appendChild(moins);
    });
    rangee.appendChild(bouton);
  }

  function tout() {
    document.querySelectorAll('[data-pv-une-ligne]').forEach(replier);
  }

  var minuteur = null;
  var largeur = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth === largeur) return;
    largeur = window.innerWidth;
    clearTimeout(minuteur);
    minuteur = setTimeout(tout, 150);
  });

  function lancer() {
    // Les photos donnent leur taille aux vignettes : on attend qu'elles soient posées.
    tout();
    window.addEventListener('load', tout, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lancer);
  } else {
    lancer();
  }
})();
